import PropTypes from "prop-types";
import SoftTypography from "components/SoftTypography";
import breakpoints from "assets/theme/base/breakpoints";
import "../shared/pageTitles.css";
import "../shared/pageLayoutSpacing.css";
import "../shared/tableHeaders.css";

/**
 * Super-admin page title — 20px Inter, #101828 (see pageTitles.css).
 */
function PageTitle({
  children,
  helpUrl,
  detail = false,
  card = false,
  className = "",
  textTransform = "capitalize",
  ...rest
}) {
  const { values } = breakpoints;
  const isSmall = typeof window !== "undefined" && window.innerWidth < values.sm;
  const variant = card ? "h5" : isSmall ? "h3" : "h2";
  const titleClass = ["sd-page-title", className].filter(Boolean).join(" ");

  const helpButton = helpUrl ? (
    <button
      type="button"
      className="sd-page-title-help"
      aria-label="Help"
      onClick={() => window.open(helpUrl, "_blank")}
    >
      ?
    </button>
  ) : null;

  if (detail) {
    const heading = (
      <h1 className={`headingpage-branding sd-page-title ${className}`.trim()} {...rest}>
        {children}
      </h1>
    );
    if (!helpUrl) return heading;
    return (
      <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
        {heading}
        {helpButton}
      </div>
    );
  }

  const title = (
    <SoftTypography
      className={titleClass}
      variant={variant}
      textTransform={textTransform}
      fontWeight="600"
      {...rest}
    >
      {children}
    </SoftTypography>
  );

  if (!helpUrl) return title;

  return (
    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
      {title}
      {helpButton}
    </div>
  );
}

PageTitle.propTypes = {
  children: PropTypes.node.isRequired,
  helpUrl: PropTypes.string,
  /** Entity name on detail pages (renders h1.headingpage-branding). */
  detail: PropTypes.bool,
  /** Title inside a settings card (MUI h5). */
  card: PropTypes.bool,
  className: PropTypes.string,
  textTransform: PropTypes.string,
};

export default PageTitle;
